<template>
  <div :class="classes()" ref="wrapper">
    <div
      :class="{
        [`${el}__careServiceBudgetPackageBar`]: true,
        [`${el}__careServiceBudgetPackageBar--show`]: showBar,
      }"
    >
      <component :is="$matchMedia.l ? 'Container' : 'div'">
        <CareServiceBudgetPackageBar @onTrackingClick="onTrackingClick" />
      </component>
    </div>
    <Headline size="xs" noMargin :centered="!$matchMedia.l">
      {{ $t('cs.analysis.budgetPackage.headline') }}
      <CountUp :end="totalPerYear" suffix=" €* / Jahr" />
    </Headline>
    <Copy element="div" size="m" color="primaryBlue" :centered="!$matchMedia.l">
      {{ $t('cs.analysis.budgetPackage.pg', { value: careLevel }) }}
    </Copy>

    <div :class="`${el}__inner ${el}__inner--vertical`">
      <div :class="`${el}__row`">
        <Copy element="div" bold>{{ $t('cs.analysis.budgetPackage.approved') }}</Copy>
        <Copy :staticClass="`${el}__chart`" element="div" bold>
          <span
            :class="`${el}__progress ${el}__progress--supportSuccess`"
            :style="`width: ${approvedValueInPercent}%`"
          />
          <span :class="`${el}__price`">
            <CountUp :end="approvedValue" suffix=" €" />
          </span>
        </Copy>
      </div>
      <div :class="`${el}__row`">
        <Copy element="div" bold>{{ $t('cs.analysis.budgetPackage.desired') }}</Copy>
        <Copy :staticClass="`${el}__chart`" element="div" bold>
          <span
            :class="`${el}__progress ${el}__progress--supportWarning`"
            :style="`width: ${desiredValueInPercent}%`"
          />
          <span :class="`${el}__price`">
            <CountUp :end="desiredValue" suffix=" €" />
          </span>
        </Copy>
      </div>
    </div>

    <Copy :staticClass="`${el}__legal`" element="div" size="s">
      {{ $t('cs.analysis.budgetPackage.copy') }}
    </Copy>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Copy from '@/objects/Copy';
import CountUp from '@/objects/CountUp';
import Container from '@/objects/Container';

import mixin from '@/mixins/careService';

import CareServiceBudgetPackageBar from './CareServiceBudgetPackageBar';

export default {
  name: 'CareServiceBudgetPackage',
  props: {},
  mixins: [mixin],
  components: {
    Headline,
    Copy,
    CountUp,
    Container,
    CareServiceBudgetPackageBar,
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  data() {
    return {
      showBar: false,
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  methods: {
    onScroll() {
      const { top, height } = this.$refs.wrapper.getBoundingClientRect();
      this.showBar = top + height < 0;
    },

    onTrackingClick(labelText, element = null) {
      this.$emit('onTrackingClick', labelText, element);
    },
  },
};
</script>
